export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/users', 'admin.users-list')

    .within('admin')

    .segment('users-list', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.users'
      }],
      template: '<admin-users-list-page></admin-users-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-users-list.module" */ "./list/admin-users-list.module");
      }
    })
}
